import React from "react";
import PropTypes from "prop-types";

import DockPanelHost from "./DockPanelHost";


export default function DockTabGroup({
  node,
  registry,
  onActivate,
  onClose,
  onHide,
}) {
  const panels = node.panelIds.map(
    (panelId) => registry.get(panelId),
  );

  return (
    <section
      className="studio-dock-tabs"
      data-dock-node-id={node.id}
    >
      <div
        className="studio-dock-tabs__list"
        role="tablist"
      >
        {panels.map((panel) => (
          <button
            key={panel.id}
            type="button"
            role="tab"
            aria-selected={
              node.activePanelId === panel.id
            }
            onClick={() => onActivate(panel.id)}
          >
            {panel.title}
          </button>
        ))}
      </div>

      {panels.map((panel) => (
        <DockPanelHost
          key={panel.id}
          panel={panel}
          active={node.activePanelId === panel.id}
          onClose={onClose}
          onHide={onHide}
        />
      ))}
    </section>
  );
}


DockTabGroup.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    panelIds: PropTypes.arrayOf(
      PropTypes.string,
    ).isRequired,
    activePanelId: PropTypes.string.isRequired,
  }).isRequired,
  registry: PropTypes.shape({
    get: PropTypes.func.isRequired,
  }).isRequired,
  onActivate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
